import { AfterViewInit, Component } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'src/app/services/message.service';
import { Router } from '@angular/router';
declare const bootstrap: any;

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss'],
})
export class ForgetPasswordComponent implements AfterViewInit {
  ForgotForm: FormGroup;
  ForgetPassword = {
    UserEmailId: '',
  };
  fieldTouched!: boolean;
  constructor(
    private commonService: CommonService,
    private _fb: FormBuilder,
    private message: MessageService,
    private router: Router
  ) {
    this.ForgotForm = this._fb.group({
      UserEmailId: ['', [Validators.required]],
    });
  }

  ngAfterViewInit(): void {
    this.startCarouselManual();
  }

  EmailVerify() {
    if (this.ForgotForm.invalid) {
      this.ForgotForm.markAllAsTouched();
      this.message.errorToast('Please fill all required fields');
    } else {
      if (
        !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
          this.ForgotForm.value.UserEmailId
        )
      ) {
        this.message.errorToast('Please enter a valid email');
      } else {
        let requestBody = {
          userMailID: this.ForgotForm.value.UserEmailId,
        };
        localStorage.setItem('userMailID', JSON.stringify(requestBody));

        this.commonService.sendOTP(requestBody).subscribe((res: any) => {
          if (res.data) {
            this.fieldTouched = false;
            this.message.successToast(
              'Otp has been sent on your mail successfully'
            );
            this.router.navigate(['/VerifyOtp']);
          } else {
            this.message.errorToast(res.errorMessage);
          }
        });
      }
    }
  }

  startCarouselManual() {
    setTimeout(() => {
      var myCarousel = document.querySelector('#carouselExampleControls12');
      var carousel = new bootstrap.Carousel(myCarousel, {
        interval: 4000,
        wrap: true,
        touch: false,
        keyboard: false,
      });
    }, 0);
  }
}
